<div
  class="w-full p-2 border px-3 border-zinc-200 rounded-md focus-within:border-primary-500"
  [ngClass]="class()"
>
  <input
    #input
    (input)="onInput($event)"
    [name]="formControlName()"
    [placeholder]="placeholder()"
    [maxLength]="maxLength()"
    [readOnly]="readonly()"
    [inputMode]="inputMode()"
    type="datetime-local"
    class="w-full outline-none placeholder:text-zinc-400"
  />
</div>
